import { getReq, createUrl } from "@/infra/http";
import { AdvanceShareTemplate, AdvanceShareTemplateDesign, AdvanceShareTemplateList, AdvanceShareTemplatePaginationFilterRequest, templateFromJson, templateListFromJson } from '@/models/advance-share-template.model';
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";

export const getPagedAdvanceShareTemplates = async (input: AdvanceShareTemplatePaginationFilterRequest): Promise<PagedResponseModel<AdvanceShareTemplateList>> => {
  return await getReq(createUrl("a/AdvanceShare/Template/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => templateListFromJson(itm))
  }));
};

export const getAdvanceShareTemplate = async (id: number): Promise<BaseResponseModel<AdvanceShareTemplate>> => {
  return await getReq(createUrl(`a/AdvanceShare/Template/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: templateFromJson(res.data.result)
  }));
};

export const getPagedAdvanceShareTemplateDesigns = async (id: number, input: AdvanceShareTemplatePaginationFilterRequest): Promise<PagedResponseModel<AdvanceShareTemplateDesign>> => {
  return await getReq(createUrl(`a/AdvanceShare/Template/${id}/Designs`),
    { params: input }
  ).then((res: any) => res.data);
};
